export default function test(a: string): string {
  return `${a}ssです。`;
}
